<template>
  <Tag class="LaptopScore" :class="theme">
    {{ scoreString }}
  </Tag>
</template>

<script>
export default {
  props: {
    label: String,
    score: [Number, String],
  },
  computed: {
    scoreString() {
      if (typeof this.score === 'string') return this.score

      return this.$options.filters.decimal(this.score || 0)
    },
    theme() {
      const { score } = this

      return Object
        .entries({
          success: score > 7,
          warning: score > 4,
          danger: score <= 4,
          info: true,
        })
        .find(([_, condition]) => condition)[0]
    },
  },
}
</script>

<style lang="scss">
.LaptopScore {
  line-height: 2rem;
}
</style>
